import { FDealType, FOfferType, isAvailable } from '../../../../JsonQuery';
import { IFilter } from '../../types/filters';
import { GeoContainer } from '../../containers/filters/GeoContainer';

export const geo: IFilter = {
  availability: isAvailable(FDealType.Any, FOfferType.Any),
  component: GeoContainer,
};
